<template>
  <v-flex class="geolocation-progress" :class="[{'geoInProgessOrSuccess': (mgProgress.inProgress && !mgProgress.postContentFailed) || (!mgProgress.inProgress && mgProgress.postContentSuccess)}, {'geoFailed': !mgProgress.inProgress && mgProgress.postContentFailed}]">
    <v-flex class="content-wrapper" v-if="mgProgress.inProgress && !mgProgress.postContentFailed && mgProgress.isFirstCheck">
      <CircleLoader />
      <p class="text-info" v-html="$t('Geolocation.checkingLocation')"></p>
    </v-flex>
    <v-flex class="content-wrapper" v-if="!mgProgress.inProgress && mgProgress.postContentFailed">
        <div class="text-info"><i class="material-icons">error_outline</i><span class="failed">{{mgProgress.count === 1 ? 'Cannot verify your location': 'There are issues with your account'}}</span></div>
        <div class="btn-wrapper"><button type="button" @click="view()" class="custom-btn">{{mgProgress.count === 1 ? 'View Details': 'Show All'}}</button></div>
    </v-flex>
    <v-flex class="content-wrapper" v-if="!mgProgress.inProgress && mgProgress.postContentSuccess && mgProgress.isFirstCheck">
      <p class="text-info"><i aria-hidden="true" class="icon material-icons verified-icon">done</i><span class="mark-text">{{ $t('Geolocation.LocationVerified') }}</span></p>
    </v-flex>
  </v-flex>
</template>
<script>
import store from '@/store'
import mobileBridge from '@/library/mobileBridge'
import Icon from '@/components/common/Icon'
import CircleLoader from '@/components/common/CircleLoader'

export default {
  name: 'mobileGeolocationDialog',
  components: {
    Icon,
    CircleLoader
  },
  computed: {
    mgProgress () {
      return store.getters['getMobileGeolocationInProgress']
    }
  },
  methods: {
    view () {
      mobileBridge.showLocationMessage(this.mgProgress.id)
    }
  },
  mounted () {}
}
</script>

<style lang="stylus" scoped>
  .geolocation-progress
    // height: 40px
    color: #fff
    font-size: 13px
    position: relative
    font-weight: normal
    font-style: normal
    font-stretch: normal
    line-height: normal
    letter-spacing: normal
    font-family: inherit
    margin-bottom 40px
    .text-info
      line-height 40px
      padding-left: 5px
      margin: 0
      @media only screen and (max-device-width: 320px)
        font-size: 12px !important
      .mark-text, .failed
        font-family: inherit
        margin-left: 5px
  &.geoInProgessOrSuccess
    background-color: #1493ff
  &.geoFailed
    background-color: #ea913c
  .content-wrapper
    display flex
    padding: 0 5px
    margin-bottom 5px
    .text-info
      flex-grow: 1
    .btn-wrapper
      flex-grow: 1
      line-height: 41px
      .custom-btn
        float: right
    .material-icons
      font-size: 21px
      position: relative
      bottom: -6px
      font-weight: normal

.loader-image
  width: 13px
  height: 13px
  object-fit: contain
  border-style: solid
  border-width: 2px
  border-image-source: conic-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.67) 66%, rgba(255, 255, 255, 1) 85%, rgba(255, 255, 255, 0) 0%)
  border-image-slice: 1

.verified-icon
  color: #ffffff
  bottom: 2px !important
  margin: 0 5px
  font-size: 16px !important

.circle-loader 
  border: 4px solid #CFD6DB;
  border-top: 4px solid #0fb3a1;
  width 20px
  height 20px

</style>




// WEBPACK FOOTER //
// src/components/layout/parts/mobileGeolocationDialog.vue